import { RouterLink } from "@irati/ui/src/Link";
import React from "react";
import PropTypes from "prop-types";
import withBranding from "@irati/brand/withBranding";
import authentication from "@irati/auth";
import { getDealTileImage } from "@irati/utils/images/getImageSize/getImageSize";
import id from "@irati/utils/id";
import tracking from "@irati-tracking/perks/perks";
import { determineDealThumbnailImage, determineDealColor } from "@irati/deals/helpers/deals/appearance";
import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import DealModes from "../../enums/DealModes";
import DealPages from "../../enums/DealPages";
import PillsOverlay from "./PillsOverlay";
import DEAL_PAGES from "../../constants/dealPage";
import { StyledDeal } from "./styled/Deal";
import DealStyledBannerWrapper from "./styled/BannerWrapper";
import DealAvatar from "./styled/DealAvatar";
import DealStyledBannerImg from "./styled/DealBannerImg";
import BannerOverlay from "./styled/BannerOverlay";
import FavouriteButton from "./styled/FavouriteButton";
import DealBody from "./DealBody";
var Deal = function (props, _a) {
    var apps = _a.apps;
    var deal = props.deal, _b = props.mode, mode = _b === void 0 ? DealModes.Default : _b, page = props.page, trackingData = props.trackingData, isFavouriteDeal = props.isFavouriteDeal, className = props.className, branding = props.branding;
    var tenantImageLink = branding.businessLogoUrl, tenantColor = branding.primaryColour;
    var isPerksGoDeal = authentication.apps("perks.perksGo") && isPerksGO(deal);
    var idNamespace = id("deal", props);
    var compactMode = mode === DealModes.Compact;
    var thumbnailImage = determineDealThumbnailImage(deal, branding);
    var borderBottomColor = determineDealColor(deal, tenantImageLink, tenantColor);
    var onClickDeal = function () {
        switch (page) {
            case DealPages.SEARCH:
                tracking.clickSearchResult(deal);
                break;
            case DealPages.HOME:
                tracking.clickHomepagePerk(deal, trackingData);
                break;
            default:
                break;
        }
    };
    var handleFavChange = function (isFavourite) {
        return isFavourite ? tracking.favouritePerk(deal, DEAL_PAGES.PERK) : tracking.unfavouritePerk(deal, DEAL_PAGES.PERK);
    };
    return (React.createElement(StyledDeal, { id: idNamespace, className: className },
        React.createElement(RouterLink, { id: id("link-deal", idNamespace), to: "/info/" + deal.urlSlug, app: apps.PERKS, onClick: onClickDeal, styled: false },
            React.createElement(DealStyledBannerWrapper, null,
                React.createElement(DealStyledBannerImg, { id: id("img-banner", idNamespace), src: getDealTileImage(deal.cardImage), compactMode: compactMode }),
                React.createElement(BannerOverlay, { id: id("banner-overlay", idNamespace) }),
                isPerksGoDeal && React.createElement(PillsOverlay, { deal: deal, isFavouriteDeal: isFavouriteDeal }),
                React.createElement(DealAvatar, { id: id("img-thumb", idNamespace), compactMode: compactMode, src: thumbnailImage, small: true, withShadow: true }),
                React.createElement(FavouriteButton, { deal: deal, onChange: handleFavChange })),
            React.createElement(DealBody, { id: id("deal-body", idNamespace), deal: deal, mode: mode, isFavouriteDeal: isFavouriteDeal, borderBottomColor: borderBottomColor }))));
};
Deal.contextTypes = {
    apps: PropTypes.object.isRequired
};
export default withBranding(Deal);
